module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_16.a5beb0c2.png";